import {ITranslatedComponent, ITypefamilyMap} from "../../redux/reducers/generalReducer";
import {
    AssignmentTypeFilter,
    HeaderFilterType,
    ILocalColumnSizeSettings,
    ITextExportStatus,
    IVirtualizedTableColumn,
    IVisibleTableColumnList,
    TData,
    TDataValue,
    TDerivate,
    TDerivateColumnSettings
} from "../../components/Table/VirtualizedTableInterfaces";
import * as React from "react";
import {FilterHandler} from "../../components/Table/dataHandler/FilterHandler";
import {ILocalStorageUserProperties, UserDynTableProperty} from "../../services/UserDynTableProperties";
import {Checkbox, Icon, MenuItemProps, } from "semantic-ui-react";
import {base64toBlob, downloadExcel, EColumnKey, mapToExcelColumns, MissingPDiPAMTBsKey, PropertiesKey, SpecificFilterEnum} from "./OptionsViewUtils";
import * as _ from "lodash";
import {AutoSizer, GridCellProps, Index, MultiGrid as ReactVirtualizedGrid} from 'react-virtualized';
import DerivateHeader from "../../components/Table/components/headerComponents/DerivateHeader";
import {buildComponent} from "../../components/Table/ComponentBuilder";
import {EOBColumnKey} from "../BaseOptionsView/BaseOptionsTableUtils";
import {renderErrorToast, renderWarningToast} from "../../utils/FeedbackMessageUtils";
import {toast} from "react-toastify";
import {translate} from "react-i18next";
import {connect, Dispatch} from "react-redux";
import 'react-virtualized/styles.css';
import TableFooterActions from "../../components/Table/components/footerComponents/TableFooterActions";
import {EDefaultTableSortingKeys, ITableSort} from "../../utils/SortUtils";
import {
    CategoryTextKey,
    FlagKey,
    OptionColumnsForHeightMeasurement,
    OptionIndicatorsKey,
    OptionTypeViewKey,
    sortPSLColumns,
    sortPSLColumnsDropdown,
    StatusColumnKey
} from "./OptionColumns";
import {IPSLApproval, IRowStatusProps} from "../../services/WorkflowUtils";
import TablePagination from "../../components/Table/components/footerComponents/pagination/TablePagination";
import {
  CnrDto,
  ExcelExportResponseDto,
  ExcelPropsDto,
  LanguageDto,
  MenuDto,
  ModeltypeBasicDto,
  OptionDto,
  ResourceListOfOptionDto,
  RoleDto,
  WorkflowDto,
} from "../../services/Client";
import DataAdapterOptionsView from "./DataAdapterOptionsView";

import {
    buildTextExportStatusComponent,
    computeRowHeightInFullView,
    keepRowSorting,
    PCCDFlag,
    scrollGridToTop,
    virtualizedTableId
} from "../../components/Table/VirtualizedTableUtils";
import VirtualizedTableHeaderCell from "../../components/Table/components/headerComponents/virtualizedTableHeaderCell/VirtualizedTableHeaderCell";
import GeneralActions from "../../redux/actions/GeneralActions";
import OptionViewActions from "../../redux/actions/OptionViewActions";
import {sortCaseInsensitive} from "../../components/Table/dataHandler/Utils";
import {compose} from "redux";
import {
    selectClient,
    selectHideEmptyAssignmentsRowsAndColumns,
    selectLanguage,
    selectOptionTableSort,
    selectVirtualizedTableReload,
    selectVirtualizedTableRollback,
    selectVirtualizedTableSelectedIdList
} from "../../redux/selectors";
import HATEOASClient from "src/services/HATEOASClient";
import {IPslSelection} from "./PSL/PslSelect";
import {IReduxState} from "../../redux/IReduxState";
import {PCCDFilterEnum} from "../../components/Table/VirtualizedTableEnums";
import PCCDTextComparePopup from "./PCCDTextComparePopup";
import {AgGridReact} from "ag-grid-react";
import {onColumnResized, PSL_COL_RESIZE} from "../KumaView/utils";
import {getDefaultColDef, getPSLColumnDefs} from "./AgGridOptionColumns";
import {getGridRenderDurationAndReset, PAGE_SIZE} from "./util";
import {selectCnrList, selectTypefamilyMap, selectUserRolesMemo} from "src/redux/selectors/generalSelectors";
import {getDeAiFlags} from "src/components/Table/components/twoLanguage/AWSTranslatePreviewHandler";

interface IMapStateToProps {
    dynTableReload: boolean;
    dynTabelRollback: boolean;
    hideEmptyAssignmentsRowsAndColumns: boolean;
    client: HATEOASClient;
    dynTableSelectedIdList: string[];
    optionTableSort: ITableSort;
    userLanguage: string;
    roles: RoleDto[] | undefined;
    cnrList?: CnrDto[];
    typefamilyMap?: ITypefamilyMap;
    baseLinks?: MenuDto;
    allWorkflows?: WorkflowDto[];
}

interface IMapDispatchToProps {
    DynTableRollBack: (dynTabelRollback: boolean) => void;
    SetHideEmptyAssignmentsRowsAndColumns: (value: boolean) => void;
    DynTableSetSelectedIdList: (idList: string[]) => void;
    SetOptionTableSort: (sortObject: ITableSort) => void;
}

export interface OptionTableProps extends ITranslatedComponent, IMapStateToProps, IMapDispatchToProps {
    data: TData[];
    optionDtos: OptionDto[];
    availableDerivates: ModeltypeBasicDto[];
    derivateToColorMap: {[key: string]: string};
    columnsData: IVirtualizedTableColumn[];
    bindSort?: string[];
    loadedPSL?: IPslSelection;
    postOptions?: ResourceListOfOptionDto;
    rowSelectable?: "all" | "one";
    assignmentTypeFilterValue: AssignmentTypeFilter;
    specificTypeOptionFilter: SpecificFilterEnum;
    selectedLanguages: LanguageDto[];

    // flags
    workFlowResetStateDisabled?: (key: string, data: TData, readOnly: boolean) => boolean;
    isCellReadOnly?: (key: string, data: TData, readOnly: boolean) => boolean;
    setExportExcelFlags: (areFlagsEnabled: boolean) => void;
    resizeDisabled?: boolean;
    inEditMode?: boolean;
    exportExcel: boolean;
    isSpecificMarket: boolean;

    // eventHandlers
    onCellClick?: (key: string, index: number, data: TDataValue, visibleDerivates?: string[]) => void;
    onChange?: (key: string, data: TDataValue, index: number) => void;
    onApprove: (data: IPSLApproval, index: number) => void;
    createIOspecificOption?: (key: string, index: number) => void;
    onChangeSelect: (index: number[]) => void;
    onOptionWFReset: (index: number) => void;
    onChangeWorkflow: (key: string, objectId: any, index: number) => void;
    generationsRows: Array<any>;
    isNewGridTable: boolean;
    page: number;
    pageSize: number;
    totalElements: number;
    setPageSize: (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => void;
    onPageChange: (newPage: number, gridApi: any) => void;
    isLoadingData: boolean;
    onLazyLoad: (gridApi: any) => void;
    onNewFilterChange: (field: string, value: any) => void;
    onGridReadyParent: (params: any) => void;
    newDropDownFilters: any;
    flags: any;
    records: number;
    filterCount: number;
    newGridFilters: any;
    updatable: boolean;
    onFilterByComparingAssignmentsChange: (values: number[]) => void;
    onFilterPccdSyncDataChange: (value: boolean | null) => void;
    onSelectionChanged?: () => void;
}

interface OptionTableState {
    data: TData[];
    tempData: TData[];
    currentPage: number;
    filterValue: {[key: string]: any};
    compareAssignmentsFilterValue: Set<string>;
    columnSizeSetting: ILocalColumnSizeSettings;
    visibleColumns: IVirtualizedTableColumn[];
    rowVisibleList: IVisibleTableColumnList;
    rowSort: string[];
    rows: IVirtualizedTableColumn[];
    numberOfItems: number;
    // true for full view mode, false for normal mode
    isFullViewMode: boolean;
    activeRow: string | null;
    dropdownFilters: {
        [OptionTypeViewKey]: Set<string>,
        [StatusColumnKey]: Set<string>,
        [CategoryTextKey]: Set<string>,
        [FlagKey]: Set<string>,
    };
    selectedIdList: string[];
    isShowFilterData: boolean;

}

class OptionTable extends React.Component<OptionTableProps, OptionTableState> {
    gridRef: ReactVirtualizedGrid | null;
    gridApi: any;
    columnApi: any;
    private filterHandler: FilterHandler;
    private localStorageKey = "prompt_dynTable";
    private dataForRollBack: TData[];

    private userPropertiesSettings: UserDynTableProperty;

    constructor(props: OptionTableProps) {
        super(props);
        this.filterHandler = new FilterHandler();
        this.state = {
            data: [],
            tempData: [],
            filterValue: {},
            compareAssignmentsFilterValue: new Set<string>(),
            currentPage: 1,
            rowVisibleList: {},
            columnSizeSetting: {},
            isFullViewMode: false,
            rowSort: [],
            rows: [],
            visibleColumns: [],
            numberOfItems: 10,
            activeRow: null,
            dropdownFilters: {
                [OptionTypeViewKey]: new Set<string>(),
                [StatusColumnKey]: new Set<string>(),
                [CategoryTextKey]: new Set<string>(),
                [FlagKey]: new Set<string>(),
            },
            selectedIdList: [],
            isShowFilterData: false,
        };
        this.gridApi = null;
        this.columnApi = null;

        this.userPropertiesSettings = new UserDynTableProperty(this.localStorageKey + "_OptionsView", this.props.columnsData);
        this.onBodyScroll = this.onBodyScroll.bind(this);
        this.onDataChanged = this.onDataChanged.bind(this);
        this.handleOnCellClick = this.handleOnCellClick.bind(this);
    }

    componentDidMount() {
        this.setState({rows: this.props.columnsData}, () => {
            const filterValue: {[key: string]: boolean | string} = {};
            if (this.props.isNewGridTable) {
                this.userPropertiesSettings = new
                    UserDynTableProperty(
                        this.localStorageKey + "_OptionsView_NewGrid",
                        this.props.columnsData
                    );
            }
            let localUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.get();

            if (localUserProperties === null) {
                localUserProperties = this.userPropertiesSettings.create();
                this.userPropertiesSettings.save(localUserProperties);
            }

            this.createDropdownFilterValues(this.props.data);
            this.setState({
                data: this.props.data,
                tempData: this.props.data,
                filterValue: filterValue,
                compareAssignmentsFilterValue: new Set<string>(),
                rowSort: localUserProperties ? localUserProperties.rowSort : [],
                rowVisibleList: localUserProperties ? localUserProperties.rowVisibleList : {},
                columnSizeSetting: localUserProperties ? localUserProperties.columnSizeSetting : {}
            });
        });
    }

    componentDidUpdate(prevProps: OptionTableProps, prevState: OptionTableState) {
        if (prevProps.columnsData !== this.props.columnsData) {
            this.setState(
                {
                    rows: keepRowSorting(this.state.rowSort, this.props.columnsData),
                },
                () => this.setState({
                    visibleColumns: this.state.rows.filter(column => this.state.rowVisibleList[column.key].visible).sort(sortPSLColumns)
                })
            );
            if (!this.props.isNewGridTable) {
                const derivateListEmpty = this.state.rows.find(item =>
                    item.options !== undefined
                    && item.options.derivateList !== undefined
                    && item.options.derivateList.size === 0
                );
                if (derivateListEmpty !== undefined) {
                    renderWarningToast({message: "WARNING:DERIVATE_LIST_EMPTY"});
                } else {
                    toast.dismiss("WARNING:DERIVATE_LIST_EMPTY");
                }
                if (prevProps.data !== this.props.data) {
                    this.setState({
                        data: this.props.data,
                        currentPage: prevProps.assignmentTypeFilterValue !== this.props.assignmentTypeFilterValue ||
                            prevProps.specificTypeOptionFilter !== this.props.specificTypeOptionFilter ? 1 : this.state.currentPage
                    });
                    this.createDropdownFilterValues(this.props.data);
                }

                if (this.props.dynTableReload === true && prevProps.dynTableReload === false) {
                    this.setState({filterValue: {}, compareAssignmentsFilterValue: new Set<string>()});
                }
            }
        }

        let localUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.get();

        if (localUserProperties) {
            if (!_.isEqual(localUserProperties.columnSizeSetting, this.state.columnSizeSetting) ||
                !_.isEqual(localUserProperties.rowVisibleList, this.state.rowVisibleList) ||
                !_.isEqual(localUserProperties.rowSort, this.state.rowSort)) {
                let updatedUserProperties: ILocalStorageUserProperties | null = this.userPropertiesSettings.update(
                    this.state.rows,
                    this.state.columnSizeSetting,
                    this.state.rowVisibleList,
                    this.state.rowSort
                );

                if (updatedUserProperties) {
                    this.setState(
                        {
                            rowSort: updatedUserProperties.rowSort,
                            rowVisibleList: updatedUserProperties.rowVisibleList,
                            columnSizeSetting: updatedUserProperties.columnSizeSetting
                        },
                        () => {
                            this.userPropertiesSettings.save(updatedUserProperties);
                            this.setState({
                                visibleColumns: this.state.rows.filter(column =>
                                    this.state.rowVisibleList[column.key] &&
                                    this.state.rowVisibleList[column.key].visible).sort(sortPSLColumns)
                            });
                        }
                    );
                }
            }
        }

        //
        if (!prevProps.exportExcel && this.props.exportExcel) {
            this.excelExportV2();
        }

        if (this.props.dynTabelRollback) {
            this.createDropdownFilterValues(this.props.data);
            this.setState({data: this.dataForRollBack});
            this.props.DynTableRollBack(false);
        }

        if (this.gridRef) {
            this.gridRef.forceUpdate();
            this.gridRef.recomputeGridSize();
        }

        if (this.props.hideEmptyAssignmentsRowsAndColumns
            && this.props.assignmentTypeFilterValue !== prevProps.assignmentTypeFilterValue
            || this.props.specificTypeOptionFilter !== prevProps.specificTypeOptionFilter) {
            this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
        }
        if (prevState.rows !== this.state.rows && this.props.isNewGridTable) {
            setTimeout(() => this.autoSizeColumn("derivateStates")); // Small delay to ensure grid is updated
        }
    }

    componentWillUnmount() {
        this.props.DynTableSetSelectedIdList([]);
    }

    /**
     * Generates the excel file
     */
    private excelExportV2() {
        const {loadedPSL, setExportExcelFlags, postOptions, availableDerivates, selectedLanguages, userLanguage} = this.props;

        // @ts-ignore
        if (loadedPSL) {
            if (postOptions &&
                this.props.client.POST_excelExportV2(postOptions).canExecute()) {
                const visDerivatesToModeltypeDto: ModeltypeBasicDto[] = [];
                const optionDtos: OptionDto[] = [];
                const visibleDerivates = this.getVisibleDerivates();
                const visibleDerivatesKeys = Array.from(visibleDerivates.keys()).map(val => val.toString());
                Array.from(visibleDerivates.values()).map(visDer => {
                    const visibleDerivate = availableDerivates.find(der => DataAdapterOptionsView.createDerivateName(der, userLanguage) === visDer);
                    if (visibleDerivate) {
                        visDerivatesToModeltypeDto.push(visibleDerivate);
                    }
                });

                const extendedData = this.appendAdditionalPropertiesToData(this.state.data);
                const filterCompareDerivates = Array.from(this.state.compareAssignmentsFilterValue);
                const filterDerivatesKeys = filterCompareDerivates.map((item: string) => this.getKeyByValue(visibleDerivates, item));
                let filteredData = this.filterHandler.filterPSLData(
                    extendedData,
                    this.state.filterValue,
                    this.state.rows,
                    this.props.assignmentTypeFilterValue,
                    new Set(visibleDerivatesKeys),
                    this.props.specificTypeOptionFilter,
                    filterDerivatesKeys,
                    this.props.hideEmptyAssignmentsRowsAndColumns,
                    this.state.selectedIdList,
                    this.state.isShowFilterData,
                    this.props.dynTableSelectedIdList
                );

                if (this.props.optionTableSort.intSequence && Object.keys(this.state.filterValue).length > 0 && this.state.filterValue.hasOwnProperty('categoryText')) {

                    filteredData = filteredData.sort((a: any, b: any) => a.intSequence - b.intSequence);

                }

                // @ts-ignore there will never be a case where "_id" is undefined
                filteredData.map(option => optionDtos.push(this.props.optionDtos[option._id]));

                const reqParam: ExcelPropsDto = {
                    modelyear: loadedPSL.modelyear,
                    typefamily: loadedPSL.typefamily,
                    cnr: loadedPSL.cnr,
                    modeltypeBasicList: visDerivatesToModeltypeDto,
                    excelVisibleColumns: mapToExcelColumns(this.state.visibleColumns),
                    optionDtos,
                    selectedLanguages: selectedLanguages.map(language => language.objectId)
                };
                let excelCall = this.props.client.POST_excelExportV2(postOptions);
                if (this.props.isNewGridTable) {
                    reqParam.filters = this.props.newGridFilters;
                    excelCall = this.props.client.POST_excelExportV2_grid(postOptions);
                }
                excelCall.execute(reqParam)
                    .then((response: ExcelExportResponseDto) => {
                        this.renderExcelDownloadLinkV2(response);
                        setExportExcelFlags(false);
                    }).catch((reason: any) => {
                        setExportExcelFlags(false);
                        renderErrorToast({
                            message: "ERRORS:EXCEL_GENERATE",
                            details: reason,
                            timestamp: Date.now()
                        });
                    });
            } else {
                setExportExcelFlags(false);
                renderErrorToast({
                    message: "ERRORS:EXCEL_GENERATE",
                    details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            }
        }
    }

    /**
     * Renders the toast for excel download
     *
     * @param response
     *      the excel generated response
     */
    private renderExcelDownloadLinkV2(response: ExcelExportResponseDto) {
        toast.success(
            (
                <div className="excel-notification">
                    <h1>{this.props.t('OPTIONS_VIEW:EXCEL_SUCCESS_HEADER')}</h1>
                    <p>{this.props.t('OPTIONS_VIEW:EXCEL_SUCCESS_MESSAGE') + ':'}</p>
                    <a onClick={() => this.excelDownloadV2(response)} download={true}>
                        {response.fileName}
                    </a>
                </div>
            )
        );
    }

    /**
     * Get excel file and download it
     *
     * @param excelLink contains the file path and link for download
     */
    private excelDownloadV2 = (excelLink: ExcelExportResponseDto) => {
        downloadExcel(excelLink);
    }

    private createDropdownFilterValues = (data: TData[]) => {
        const {filterValue} = this.state;

        const optionTypes: Set<string> = new Set<string>();
        const workflowTypes: Set<string> = new Set<string>();
        const categoryTypes: Set<string> = new Set<string>();
        const flags: Set<string> = new Set<string>();

        data.map(option => {
            if (option.optionTypeView) {
                optionTypes.add(option.optionTypeView as string);
            }

            if (option.categoryText) {
                categoryTypes.add(option.categoryText as string);
            }
            // @ts-ignore
            const workflowStepName = option.statusView && option.statusView.statusValueStates && option.statusView.statusValueState
                // @ts-ignore
                && option.statusView.statusValueStates.find(state => state.id === option.statusView.statusValueState);
            if (workflowStepName) {
                // the hover text contains also the reject message
                workflowTypes.add(workflowStepName.hoverText.split(" - ")[0] as string);
            }

            // @ts-ignore ts complains that value property does not exists, but it does
            if (option.flags && option.flags.value && option.flags.value.length > 0) {
                // @ts-ignore
                option.flags.value.map(flag => flags.add(flag.textLabel));
            }
        });

        // clean filter value if no longer available
        if (filterValue[OptionTypeViewKey]) {
            filterValue[OptionTypeViewKey].forEach((value: string) => {
                if (!optionTypes.has(value)) {
                    filterValue[OptionTypeViewKey].delete(value);
                }
            });
        }

        if (filterValue[CategoryTextKey]) {
            filterValue[CategoryTextKey].forEach((value: string) => {
                if (!categoryTypes.has(value)) {
                    filterValue[CategoryTextKey].delete(value);
                }
            });
        }

        if (filterValue[StatusColumnKey]) {
            filterValue[StatusColumnKey].forEach((value: string) => {
                if (!workflowTypes.has(value)) {
                    filterValue[StatusColumnKey].delete(value);
                }
            });
        }

        if (filterValue[FlagKey]) {
            filterValue[FlagKey].forEach((value: string) => {
                if (!flags.has(value)) {
                    filterValue[FlagKey].delete(value);
                }
            });
        }

        this.setState({
            dropdownFilters: {
                [OptionTypeViewKey]: new Set(Array.from(optionTypes).sort(sortCaseInsensitive)),
                [StatusColumnKey]: new Set(Array.from(workflowTypes).sort(sortCaseInsensitive)),
                [CategoryTextKey]: categoryTypes,
                [FlagKey]: new Set(Array.from(flags).sort(sortCaseInsensitive)),
            },
            filterValue: filterValue
        });
    }

    private getVisibleDerivates = (): Map<number, string> => {
        let loadedPSLDerivateSetting: TDerivateColumnSettings | undefined;
        const {rows} = this.state;
        const {userLanguage} = this.props;

        if (this.state.rowVisibleList && this.state.rowVisibleList[EColumnKey.DerivateKey] &&
            this.state.rowVisibleList[EColumnKey.DerivateKey].hiddenDerivates) {
            let _hiddenDerivateList: TDerivateColumnSettings[] | undefined = this.state.rowVisibleList[EColumnKey.DerivateKey].hiddenDerivates;
            if (_hiddenDerivateList !== undefined) {
                loadedPSLDerivateSetting = _hiddenDerivateList.find((item) => _.isEqual(item.pslSelection, this.props.loadedPSL));
            }
        }

        const derivateStates = rows.find(item => item.key === EColumnKey.DerivateKey);
        if (derivateStates
            && derivateStates.options
            && derivateStates.options.derivateList
            && derivateStates.options.derivateList.size > 0) {
            let loadedPSLVisibleDerivates = derivateStates.options.derivateList;
            const updatedLoadedPSLVisibleDerivates = new Map<number, string>();

            // remove hidden derivates
            if (loadedPSLDerivateSetting && loadedPSLDerivateSetting.derivates) {
                // @ts-ignore
                loadedPSLVisibleDerivates.forEach((value: string, key: number) => {
                    if (loadedPSLDerivateSetting && !loadedPSLDerivateSetting.derivates.includes(key)) {
                        updatedLoadedPSLVisibleDerivates.set(key, value);
                    }
                });
            } else {
                // in the case of select all, loadedPSLDerivateSetting is undefined, show all the derivates.
                loadedPSLVisibleDerivates.forEach((value: string, key: number) => {
                    updatedLoadedPSLVisibleDerivates.set(key, value);
                });
            }

            return updatedLoadedPSLVisibleDerivates;
        }

        return new Map<number, string>();
    }

    /**
     * De/Select all items(based on filtered data)
     */
    private selectAll(checked: boolean, filteredData: TData[]) {
        let selectedIdSet = new Set(this.props.dynTableSelectedIdList);
        // select or deselect all filtered data (works the same if no filter is set)
        filteredData.forEach((entry: TData) => {
            if (entry._id) {
                if (checked) {
                    selectedIdSet.add(entry._id);
                } else {
                    selectedIdSet.delete(entry._id);
                }
            }
        });

        const selectedIdList = Array.from(selectedIdSet);
        const indexList = selectedIdList.map((item: string) => parseInt(item, 10));

        // TODO the select ids are stored in 2 places. This should be refactored
        this.props.DynTableSetSelectedIdList(selectedIdList);
        this.props.onChangeSelect(indexList);
        this.setState({selectedIdList: [...selectedIdList]});
    }

    /**
     * processes the change to the selection array
     * @param checked is the row selected
     * @param rowNumber target rowNumber
     */
    private onChangeRowSelection(checked: boolean, rowId: string) {
        let selectedIdList: string[] = [];
        if (this.props.rowSelectable === "all")
            selectedIdList = [... this.props.dynTableSelectedIdList];

        if (checked) {
            selectedIdList.push(rowId);
        }
        else {
            _.pull(selectedIdList, rowId);
        }
        const indexList = selectedIdList.map((item) => parseInt(item, undefined));
        this.props.DynTableSetSelectedIdList(selectedIdList);
        if (this.props.onChangeSelect) {
            this.props.onChangeSelect(indexList);
        }
        this.setState({selectedIdList: [...selectedIdList]});
    }

    private showSelectedData = () => {
        if (this.state.isShowFilterData) {
            this.setState({isShowFilterData: false, filterValue: {}});
        } else {
            this.setState({isShowFilterData: true});
        }
    }

    /**
     * on cell value changed
     */
    private onDataChanged(key: string, rowNumber: number, newValue: any) {
        const data = [...this.props.data];
        this.dataForRollBack = _.cloneDeep(data);
        if (key === OptionIndicatorsKey) {
            if (this.props.onChange) {
                this.props.onChange(key, newValue, rowNumber);
            }
        }

        if (_.isEqual(data[rowNumber][key], newValue)) {
            return;
        }

        if (!this.props.isNewGridTable) {
            data[rowNumber][key] = newValue;
        }

        const row = data[rowNumber] as any;
        let aiMeta: any = null;

        if (newValue) {
            for (const k in newValue) {
                if (!Object.prototype.hasOwnProperty.call(newValue, k)) {
                    continue;
                }

                const v = newValue[k];
                if (v && v.aiMeta) {
                    aiMeta = v.aiMeta;
                    break;
                }
            }
        }

        if (
          aiMeta &&
          row &&
          row.optionIndicators &&
          row.optionIndicators.dto &&
          Array.isArray(row.optionIndicators.dto.texts)
        ) {
          const texts = row.optionIndicators.dto.texts;

          for (let i = 0; i < texts.length; i++) {
            const t = texts[i];

            if (aiMeta.aiGeneratedShorttext !== undefined) {
            t.aiGeneratedShorttext = aiMeta.aiGeneratedShorttext;
            }
            if (aiMeta.aiGeneratedLongtext !== undefined) {
            t.aiGeneratedLongtext = aiMeta.aiGeneratedLongtext;
            }
            if (aiMeta.aiGeneratedFooter !== undefined) {
            t.aiGeneratedFooter = aiMeta.aiGeneratedFooter;
            }
            if (aiMeta.aiGeneratedUsp !== undefined) {
            t.aiGeneratedUsp = aiMeta.aiGeneratedUsp;
            }
          }
        }

        if (
          !aiMeta &&
          row &&
          row.optionIndicators &&
          row.optionIndicators.dto &&
          Array.isArray(row.optionIndicators.dto.texts)
        ) {
          const texts = row.optionIndicators.dto.texts;

          for (let i = 0; i < texts.length; i++) {
            if (key === "shorttext") {
            texts[i].aiGeneratedShorttext = false;
            }

            if (key === "longtext") {
            texts[i].aiGeneratedLongtext = false;
            }

            if (key === "footer") {
            texts[i].aiGeneratedFooter = false;
            }
            if (key === "usp") {
            texts[i].aiGeneratedUsp = false;
            }
          }
        }

        this.setState({ data, isShowFilterData: false }, () => {
            if (this.props.onChange) {
                this.props.onChange(key, newValue, rowNumber);
            }

            if (this.gridApi) {
                const rowNode = this.gridApi.getDisplayedRowAtIndex(rowNumber);
                if (rowNode) {
                    rowNode.setData({
                        ...rowNode.data,
                        ...row
                    });

                    this.gridApi.refreshCells({
                        rowNodes: [rowNode],
                        force: true
                    });
                }
            }
        });
    }

    /**
     * on cell click for option constrain and exclusion and derivates(for now)
     */
    private handleOnCellClick(key: string, index: number, value: any, visibleDerivates?: string[]): void {
        if (this.props.onCellClick !== undefined) {
            if (visibleDerivates && visibleDerivates.length > 0) {
                this.props.onCellClick(key, index, value, visibleDerivates);
            } else {
                this.props.onCellClick(key, index, value);
            }
        }
    }

    private onFilterChange = (newHeaderFilter: HeaderFilterType) => {
        scrollGridToTop();
        if (this.props.hideEmptyAssignmentsRowsAndColumns) {
            this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
        }
        this.setState({
            filterValue: newHeaderFilter,
            currentPage: 1,
        });
        // Handle PCCD filter specifically
        if ('pccdFlag' in newHeaderFilter && this.props.isNewGridTable) {
            const pccdValue = newHeaderFilter.pccdFlag;
            if (pccdValue === '') {
                this.props.onFilterPccdSyncDataChange(null);
            } else {
                const pccdBool = typeof pccdValue === 'string'
                    ? pccdValue.toLowerCase() === 'true'
                    : Boolean(pccdValue);
                this.props.onFilterPccdSyncDataChange(pccdBool);
            }
        }
    }
    private getDerivateIdsByNames = (compareAssignmentsArray: string[], derivateList: Map<number, string>): number[] => {
        const matchedIds: number[] = [];
        derivateList.forEach((name, id) => {
            if (compareAssignmentsArray.includes(name)) {
                matchedIds.push(id);
            }
        });
        return matchedIds;
    }
    private onFilterByComparingAssignments = (newCompareAssignmentsFilterValue: Set<string>) => {
        scrollGridToTop();
        if (this.props.hideEmptyAssignmentsRowsAndColumns) {
            this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
        }
        this.setState({
            compareAssignmentsFilterValue: newCompareAssignmentsFilterValue,
            currentPage: 1,
        });
        if (this.props.isNewGridTable && newCompareAssignmentsFilterValue.size > 1) {
            const derivateStatesItem = this.props.columnsData.find((item) => item.key === EColumnKey.DerivateKey);
            if (derivateStatesItem && derivateStatesItem.options && derivateStatesItem.options.derivateList) {
                const derivateList = derivateStatesItem.options.derivateList as Map<number, string>;
                const compareAssignmentsArray = Array.from(newCompareAssignmentsFilterValue);
                const matchedDerivateIds = this.getDerivateIdsByNames(compareAssignmentsArray, derivateList);
                this.props.onFilterByComparingAssignmentsChange(matchedDerivateIds);
            }
        } else if (this.props.isNewGridTable && newCompareAssignmentsFilterValue.size <= 1) {
            this.props.onFilterByComparingAssignmentsChange([]);
        }
    }

    private setNumberOfItems = (e: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => {
        this.setState(
            {
                numberOfItems: data.value,
                currentPage: 1,
            },
            scrollGridToTop
        );
    }

    private setActiveRow = (optionId: string) => {
        this.setState({activeRow: optionId});
    }

    private clearActiveRow = () => {
        this.setState({activeRow: null});
    }

    private onSort = (key: string, isAscending: boolean) => {
        const sortObject = {...this.props.optionTableSort};
        if (key === EDefaultTableSortingKeys.categoryText || key === EDefaultTableSortingKeys.intSequence) {
            sortObject[key] = isAscending;
        } else {
            sortObject.thirdKey = key === sortObject.thirdKey && isAscending === sortObject.thirdKeyAsc ? undefined : key;
            sortObject.thirdKeyAsc = key === this.props.optionTableSort.thirdKey
                && isAscending === this.props.optionTableSort.thirdKeyAsc ? undefined : isAscending;
        }
        this.props.SetOptionTableSort(sortObject);
    }

    private handleTableMenuChange = (
        rowVisibleList: any,
        resetHideEmptyRowsAndColumnsFilter?: boolean,
        key?: string,
        clearHeaderFilters?: boolean
    ) => {
        if (clearHeaderFilters) {
            let newFilter = {...this.state.filterValue};
            Object.keys(this.state.filterValue).forEach(keyFilter => newFilter[keyFilter] = undefined);
            this.onFilterChange(newFilter);
        } else if (key && this.state.filterValue[key]) {
            this.onFilterChange({...this.state.filterValue, [key]: undefined});
        }

        this.setState({rowVisibleList}, () => {
            // update filter in case some derivates were set as invisible
            const newCompareAssignmentsFilterValue = new Set<string>(this.state.compareAssignmentsFilterValue);
            const visibleDerivates = this.getVisibleDerivates();
            this.state.compareAssignmentsFilterValue.forEach(der => {
                if (!Array.from(visibleDerivates.values()).includes(der)) {
                    newCompareAssignmentsFilterValue.delete(der);
                }
            });

            if (resetHideEmptyRowsAndColumnsFilter && this.props.hideEmptyAssignmentsRowsAndColumns) {
                this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
            }
            this.setState({
                rowSort: Object.keys(_.pickBy(this.state.rowVisibleList, (item) => item.visible)),
                compareAssignmentsFilterValue: newCompareAssignmentsFilterValue,
            });
            // need to look over here

            if (this.columnApi) {
                const allColumnIds = Object.keys(_.pickBy(this.state.rowVisibleList, (item) => item.visible));
                this.columnApi.autoSizeColumns(allColumnIds);
                if (!key) {
                    if (visibleDerivates.size > 0) {
                        this.columnApi.setColumnWidth('derivateStates', visibleDerivates.size * 50); // Set the width dynamically
                        this.columnApi.setColumnVisible("derivateStates", true); // Hide or show the column
                    } else {
                        this.columnApi.setColumnVisible("derivateStates", false); // Hide or show the column
                    }
                }
                this.columnApi.getAllColumns().forEach((column: any) => {
                    if (column.colDef.key === EColumnKey.DerivateKey) {
                        return;
                    }
                    const shouldBeVisible = allColumnIds.includes(column.colDef.key);
                    if (column.isVisible() !== shouldBeVisible) {
                        const colId = column.getColId();
                        this.columnApi.setColumnVisible(colId, shouldBeVisible);
                    }
                });

            }
        });
    }

    /**
     * Returns the visible column for rendering the cell
     * If there are no visible derivates, then skip the derivatesColumn
     * this is needed because the implementation for the visibleDerivates is different
     * than for the other columns (and would require a refactoring)
     */
    private getVisibleColumn = (
        columnIndex: number,
        visibleDerivatesCount: number,
        derivateColumnIndex: number
    ): IVirtualizedTableColumn => {
        if (visibleDerivatesCount === 0 && columnIndex - 1 >= derivateColumnIndex) {
            return this.state.visibleColumns[columnIndex];
        } else {
            return this.state.visibleColumns[columnIndex - 1];
        }
    }
    /**
     *  Computes the number of visible columns so the Grid knows
     *  how many to render.
     *
     *  The derivates array is considered as one column.
     */
    private getColumnCount = (visibleDerivatesCount: number): number => {
        return this.state.visibleColumns.length + (visibleDerivatesCount > 0 ? 1 : 0);
    }

    /**
     *  Returns the width of the cells to the Grid according
     *  to the user settings.
     *
     *  The width of derivates column is computed by multiplying
     *  th8e number of derivates with 50.
     */
    private getColumnWidth = ({index}: Index, visibleDerivatesCount: number, derivateColumnIndex: number): number => {
        if (index === 0) {
            return 70;
        }
        const visibleColumn = this.getVisibleColumn(index, visibleDerivatesCount, derivateColumnIndex);
        const {columnSizeSetting} = this.state;
        if (visibleColumn && visibleColumn.key === EColumnKey.DerivateKey) {
            return visibleDerivatesCount * 50;
        }
        return columnSizeSetting[visibleColumn.key] ? columnSizeSetting[visibleColumn.key].width + 20 : 120;
    }

    /**
     * Returns the height of the row.
     *
     * The header has a fixed height of 150, and the rows 120.
     * If full-view-mode is on, then CellMeasurer will be used.
     */
    private getRowHeight = ({index}: Index, filteredData: any[], columns: IVirtualizedTableColumn[]): number => {

        if (index === 0) {
            return 150;
        }
        return this.state.isFullViewMode
            ? filteredData[index - 1]
                ? computeRowHeightInFullView(filteredData[index - 1], columns, this.state.columnSizeSetting)
                : 100
            : 100;
    }

    /**
     * Computes the derivate columns that don't have any assignments
     *
     * @param visibleDerivates
     *      list of all visible derivates
     * @param data
     *      psl data
     */
    private getEmptyDerivates(visibleDerivates: number[], data: TData[]): number[] {
        let derivateFinalList: number[] = [];

        data.forEach((dataValue: TData) => {
            let item = dataValue!.derivateStates;
            if (item !== undefined) {
                Object.keys(item).map((key) => {
                    if (!derivateFinalList.includes(+key)) {
                        derivateFinalList.push(+key);
                    }
                });
            }
        });
        return visibleDerivates.filter((elem) => !derivateFinalList.includes(elem));
    }

    private deSelectAll = () => {
        this.props.DynTableSetSelectedIdList([]);
        this.props.onChangeSelect([]);
        this.setState({data: [...this.state.tempData], isShowFilterData: false, selectedIdList: []});
    }
    private isChecked = (data: any, rowIndex: number) => {
        if (this.state.isShowFilterData) {
            return true;
        }
        return this.props.dynTableSelectedIdList.findIndex((rowId) => data[rowIndex - 1]._id === rowId) > -1;
    }
    /**
     *  Computes the cells for the Grid based on the indexes
     *  passed from the Grid renderer function.
     */
    private renderGridCell = (
        {columnIndex, key, rowIndex, style, parent}: GridCellProps,
        data: any[],
        visibleDerivates: Map<number, string>,
        derivateColumnIndex: number,
        filteredData: TData[],
    ): React.ReactNode => {

        const visibleColumn = this.getVisibleColumn(columnIndex, visibleDerivates.size, derivateColumnIndex);
        if (visibleColumn && visibleColumn.key === 'derivateStates') {
            if (visibleColumn.options && visibleColumn.options.derivateList) {
                const availableDerivatesObjId = this.props.availableDerivates.map(der => der.objectId);
                Array.from(visibleColumn.options.derivateList.keys()).map((derivate) => {
                    if (!availableDerivatesObjId.includes(derivate)) {
                        visibleDerivates.delete(derivate);
                    }
                });
            }

        }

        if (data.length === 0 && rowIndex === 1) {
            return <div className='grid-empty-row' key={key} style={style} />;
        }
        if (columnIndex === 0 && rowIndex === 0) {
            // true if all the filtered items are included in the selected items list (works the same if no filter is set)
            const checked = filteredData.every((td: TData) =>
                td._id !== undefined && this.props.dynTableSelectedIdList.includes(td._id));
            return (
                <div
                    className='grid-first-column-row grid-border-left grid-border-bottom grid-border-right grid-border-top'
                    key={key}
                    style={style}
                >
                    {this.props.rowSelectable &&
                        <>
                            <Checkbox
                                checked={checked}
                                slider={true}
                                onChange={(e, v) => this.selectAll(v.checked as boolean, filteredData)}
                            />
                            {this.props.dynTableSelectedIdList.length > 0 &&
                                <div style={{display: "flex", height: '10px', justifyContent: 'space-between'}}>
                                    <a
                                        onClick={this.showSelectedData}
                                        className="ui table-header-button active-dropdown-button circular label"
                                        style={{minWidth: 40, marginLeft: -5}}
                                    >
                                        <p style={{fontSize: '10px'}}>{this.props.dynTableSelectedIdList.length}</p>
                                    </a>
                                    <a className="ui table-header-button circular dont label" onClick={() => this.deSelectAll()} style={{fontSize: 10}}>
                                        <Icon name="dont" />
                                    </a>
                                </div>
                            }
                        </>
                    }
                </div>
            );
        }

        if (rowIndex === 0) {
            return this.renderGridHeader(columnIndex, key, style, visibleDerivates, visibleColumn);
        }

        if (columnIndex === 0) {
            return (
                <div
                    className={`grid-centered-cell grid-border-left grid-border-bottom grid-border-right ${rowIndex % 2 === 1 ? 'grid-white-row' : 'grid-grey-row'}
                    ${this.props.isSpecificMarket ?
                            data[rowIndex - 1].rowClass === 'table-invalid-pdip-row'
                                ? 'table-invalid-pdip-first-cell'
                                : data[rowIndex - 1].rowClass === 'table-invalid-pdip-option-type-row'
                                    ? 'table-invalid-pdip-option-type-first-cell'
                                    : data[rowIndex - 1].rowClass
                            : ''
                        }
                    ${data[rowIndex - 1]._id === this.state.activeRow ? 'table-active-row' : ''}`}
                    key={key}
                    style={style}
                >
                    {this.props.rowSelectable && <Checkbox
                        slider={true}
                        checked={this.isChecked(data, rowIndex)}
                        disabled={this.state.isShowFilterData}
                        onChange={(e, v) => {
                            this.onChangeRowSelection(v.checked as boolean, data[rowIndex - 1]._id as string);
                        }}
                    />}

                </div>
            );

        }

        return this.renderGridBody(rowIndex, columnIndex, key, style, data, visibleDerivates, visibleColumn);
    }

    /**
     *  Computes the cells of the fixed row in the Grid (Header)
     */
    private renderGridHeader = (
        columnIndex: number,
        key: string, style: React.CSSProperties,
        visibleDerivates: Map<number, string>,
        visibleColumn: IVirtualizedTableColumn,
    ): React.ReactNode => {

        if (this.state.rowVisibleList[visibleColumn.key] && !this.state.rowVisibleList[visibleColumn.key].visible)
            return null;
        // is derivate?
        const isDerivate = visibleColumn.options && visibleColumn.options.derivateList && visibleColumn.options.derivateList.size > 0;
        if (visibleColumn.options && visibleColumn.options.derivateList && visibleColumn.options.derivateList.size === 0) {
            return null;
        }

        if (isDerivate) {
            return (
                <div
                    className='grid-header-derivate-cell grid-border-top grid-border-bottom'
                    key={key}
                    style={style}
                >
                    <DerivateHeader
                        derivates={visibleDerivates}
                        derivateToColorMap={this.props.derivateToColorMap}
                        isBasicMarketLoaded={this.props.loadedPSL !== undefined && this.props.loadedPSL.cnr.cnr === PropertiesKey.BasicMarketCnrKey}
                    />
                </div>
            );
        }

        let isAscending;

        if (visibleColumn.key === EDefaultTableSortingKeys.categoryText || visibleColumn.key === EDefaultTableSortingKeys.intSequence) {
            isAscending = this.props.optionTableSort[visibleColumn.key];
        } else if (this.props.optionTableSort.thirdKey === visibleColumn.key) {
            isAscending = this.props.optionTableSort.thirdKeyAsc;
        }

        return (
            <VirtualizedTableHeaderCell
                t={this.props.t}
                key={key}
                hasDropdown={true}
                isTallHeader={true}
                isAscending={isAscending}
                visibleColumn={visibleColumn}
                style={style}
                columnSizeSetting={this.state.columnSizeSetting}
                filterValue={this.state.filterValue}
                setState={(newColumnWidth: ILocalColumnSizeSettings) => this.setState({columnSizeSetting: newColumnWidth})}
                onFilterChange={(filterKey, value) => this.onFilterChange({...this.state.filterValue, [filterKey]: value})}
                onSort={this.onSort}
                dropdownFilters={this.state.dropdownFilters}
            />
        );
    }

    /**
     *  Computes the cells of the Grid body
     */
    private renderGridBody = (
        rowIndex: number,
        columnIndex: number,
        keyGrid: string,
        style: React.CSSProperties,
        data: TData[],
        visibleDerivates: Map<number, string>,
        visibleColumn: IVirtualizedTableColumn,
    ): React.ReactNode => {

        const item: TData = data[rowIndex - 1];
        let readOnly: boolean = item.isDisabled !== undefined ? item.isDisabled as boolean : false;
        const rowClass: string = `${this.props.isSpecificMarket
            ? data[rowIndex - 1].rowClass
                ? data[rowIndex - 1].rowClass : 'row-BASIC'
            : ''}`;

        const key: string = visibleColumn.key;
        const TargetComponent = buildComponent(visibleColumn.rowType);
        const options = visibleColumn.options || {};
        // this is an index, not the real option dto id
        const id: number = parseInt(item._id as string, 10);
        let activeRowClassName = '';
        if (item._id === this.state.activeRow) {
            activeRowClassName = 'table-active-row';
        }
        const className = `grid-centered-cell grid-border-bottom grid-border-right ${rowIndex % 2 === 1 ? 'grid-white-row' : 'grid-grey-row'} ${rowClass} ${activeRowClassName}`;

        if (!readOnly && options.readOnly !== null && options.readOnly !== undefined) {
            readOnly = options.readOnly;
        }

        if (key === EColumnKey.DerivateKey) {
            const isSpecificPSL = !!(this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey);
            // display only cells for visible derivates
            const derivateReadOnly = readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly;
            if (visibleDerivates.size > 0)
                return (
                    <div
                        className={`display--flex grid-border-bottom ${activeRowClassName} ${rowIndex % 2 === 1 ? 'grid-white-row' : 'grid-grey-row'} ${rowClass}`}
                        style={style}
                        key={keyGrid}
                        onClick={() => !derivateReadOnly && this.handleOnCellClick(key, id, item.derivateStates, Array.from(visibleDerivates.values()))}
                    >
                        <TargetComponent
                            t={this.props.t}
                            rowIndex={rowIndex}
                            derivates={visibleDerivates}
                            uglyMode={this.state.isFullViewMode}
                            value={item[key]}
                            language={this.props.i18n.language}
                            workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                            inputWithPopup={options.inputWithPopup}
                            onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                            readOnly={derivateReadOnly}
                            inEditMode={this.props.inEditMode}
                            derivateToColorMap={this.props.derivateToColorMap}
                            isSpecificPSL={isSpecificPSL}
                            missingPDiPAMTBs={isSpecificPSL ? item[MissingPDiPAMTBsKey] as Set<string> : undefined}
                        />
                    </div>
                );
            return undefined;
        }
        else if (key === EColumnKey.OptionBasicViewKey)
            return (
                <div
                    className={className}
                    key={keyGrid}
                    style={style}
                >
                    <div style={{display: "flex", alignItems: "center"}}>
                        {
                            !item.pccdFlag &&
                            <PCCDTextComparePopup
                                item={item}
                                t={this.props.t}
                            />
                        }
                        {/* {
                            buildTextExportStatusComponent((item[EOBColumnKey.ExportStatus]) as ITextExportStatus)
                        } */}
                        <div style={{width: '100%'}}>
                            <TargetComponent
                                t={this.props.t}
                                rowIndex={rowIndex}
                                derivates={new Map}
                                language={this.props.i18n.language}
                                uglyMode={this.state.isFullViewMode}
                                workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                                value={item[key]}
                                onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                                readOnly={readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly}
                                inEditMode={this.props.inEditMode}
                            />
                        </div>
                    </div>
                </div>
            );
        else if (key === EColumnKey.StatusViewKey) {
            const statusData = item[key] as IRowStatusProps;
            const itemAny = item as any;
            let extractedOptionBasic = undefined;
            if (itemAny.optionIndicators && itemAny.optionIndicators.dto) {
                    extractedOptionBasic = itemAny.optionIndicators.dto.optionBasic;
            }
            return (
                <div
                    className={className}
                    key={keyGrid}
                    style={style}
                >
                    <TargetComponent
                        t={this.props.t}
                        rowIndex={rowIndex}
                        derivates={new Map}
                        language={this.props.i18n.language}
                        uglyMode={this.state.isFullViewMode}
                        workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                        value={{
                            ...statusData,
                            optionBasic: extractedOptionBasic
                        }}
                        allWorkflows={this.props.allWorkflows}
                        onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                        // @ts-ignore
                        onApprove={(newValue: IPSLApproval) => this.props.onApprove(newValue, id)}
                        readOnly={readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly}
                        inEditMode={this.props.inEditMode}
                        createIOspecificOption={() => this.props.createIOspecificOption && this.props.createIOspecificOption(key, id)}
                        // 'id' is actually an index, not the real option dto id
                        onChangeWorkflow={() => this.props.onChangeWorkflow && this.props.onChangeWorkflow(key, item[EColumnKey.ObjectIDKey], id)}
                        onOptionWFReset={() => this.props.onOptionWFReset(id)}
                    />
                </div>
            );
        } else if (key === EColumnKey.LongtextKey) {
            const { aiGeneratedShorttext, aiGeneratedLongtext, aiGeneratedFooter, aiGeneratedUsp } = getDeAiFlags(item);
            const shorttext = item.shorttext as any;
            const usp = item.usp as any;
            const objId = item.objectId as number;
            const hasShortTextDe = Array.isArray(shorttext) && shorttext.some((s: any) =>
                s.flag === 'de' && s.value && s.value.trim()
            );

            const hasUspDe = Array.isArray(usp) && usp.some((u: any) =>
                u.flag === 'de' && u.value && u.value.trim()
            );
            const longTextSuggestion = !!(hasShortTextDe && hasUspDe);
            return (
                <div
                    className={className}
                    key={keyGrid}
                    style={style}
                >
                    <TargetComponent
                        t={this.props.t}
                        rowIndex={rowIndex}
                        derivates={new Map}
                        language={this.props.i18n.language}
                        uglyMode={this.state.isFullViewMode}
                        workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                        value={item[key]}
                        onCellClick={() => this.handleOnCellClick(key, id, item[key])}
                        onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                        readOnly={readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly}
                        inEditMode={this.props.inEditMode}
                        isSpecificPSL={!!(this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey)}
                        maintainedTextsIconColor={'red'}
                        setActiveRow={() => item._id && this.setActiveRow(item._id)}
                        clearActiveRow={this.clearActiveRow}
                        editDialogHeader={{
                            dialogTitle: this.props.t('OPTIONS_VIEW:EDIT_OPTION'),
                            previewAiHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_HEADER'),
                            previewAiSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_SUB_HEADER'),
                            previewAiOriginal: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_ORIGINAL'),
                            previewAiPreview: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_PREVIEW'),
                            previewAiConfirm: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM'),
                            previewAiCancel: this.props.t('GLOBAL:CANCEL'),
                            previewAiConfimChange: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM_CHANGES'),
                            previewAiGrammarSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_GRAMMAR_SUB_HEADER'),
                            previewAiGenerateSubHeader: this.props.t('GLOBAL:GLOBAL_AI_GENERATE_SUBHEADER'),
                            tooltipAiTranslate: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP'),
                            tooltipAiGenerate: this.props.t('GLOBAL:GLOBAL_AI_TOOLTIP_GENERATE'),
                            tooltipAiGrammar:this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP_GRAMMAR'),
                            optionCode: item.optionBasicView ? item.optionBasicView as string : "",
                            editingColumn: this.state.visibleColumns[columnIndex - 1].label,
                            optionType: item.optionTypeView ? item.optionTypeView as string : "",
                            pdipText: item.pdiptext as string
                        }}
                        isEditor={true}
                        longTextSuggestion={longTextSuggestion}
                        client={this.props.client}
                        postOptions={this.props.postOptions}
                        apiMethod={(client, postOptions) => client.POST_optionAWSTranslate(postOptions)}
                        baseLinks={this.props.baseLinks}
                        grammarApiMethod={(client, unusedPostOptions) =>
                            this.props.baseLinks
                                ? client.POST_awsBedrockGrammar(this.props.baseLinks)
                                : { execute: () => Promise.reject("Links not loaded") }
                        }
                        suggestionApiMethod={(client, unusedPostOptions) => {
                            return client.GET_awsBedrockGenerateText(objId);
                        }}
                        objectId={objId}
                        pslAiGeneratedShorttext={aiGeneratedShorttext}
                        pslAiGeneratedLongtext={aiGeneratedLongtext}
                        aiGeneratedFooter={aiGeneratedFooter}
                        aiGeneratedUsp={aiGeneratedUsp}
                    />
                </div>
            );
        } else if (key === EColumnKey.ShorttextKey) {
            const { aiGeneratedShorttext, aiGeneratedLongtext, aiGeneratedFooter, aiGeneratedUsp } = getDeAiFlags(item);
            return (
                <div
                    className={className}
                    key={keyGrid}
                    style={style}
                >
                    <div style={{display: "flex", alignItems: "center", height: '100%'}}>
                        <div style={{width: '100%', height: '100%'}}>
                            <TargetComponent
                                t={this.props.t}
                                rowIndex={rowIndex}
                                derivates={new Map}
                                language={this.props.i18n.language}
                                uglyMode={this.state.isFullViewMode}
                                workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                                value={item[key]}
                                onCellClick={() => this.handleOnCellClick(key, id, item[key])}
                                onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                                readOnly={readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly}
                                inEditMode={this.props.inEditMode}
                                isSpecificPSL={!!(this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey)}
                                setActiveRow={() => item._id && this.setActiveRow(item._id)}
                                clearActiveRow={this.clearActiveRow}
                                editDialogHeader={{
                                    dialogTitle: this.props.t('OPTIONS_VIEW:EDIT_OPTION'),
                                    previewAiHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_HEADER'),
                                    previewAiSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_SUB_HEADER'),
                                    previewAiOriginal: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_ORIGINAL'),
                                    previewAiPreview: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_PREVIEW'),
                                    previewAiConfirm: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM'),
                                    previewAiCancel: this.props.t('GLOBAL:CANCEL'),
                                    previewAiConfimChange: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM_CHANGES'),
                                    previewAiGrammarSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_GRAMMAR_SUB_HEADER'),
                                    tooltipAiTranslate: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP'),
                                    tooltipAiGrammar:this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP_GRAMMAR'),
                                    optionCode: item.optionBasicView ? item.optionBasicView as string : "",
                                    editingColumn: this.state.visibleColumns[columnIndex - 1].label,
                                    optionType: item.optionTypeView ? item.optionTypeView as string : "",
                                    pdipText: item.pdiptext as string
                                }}
                                isEditor={false}
                                client={this.props.client}
                                postOptions={this.props.postOptions}
                                apiMethod={(client, postOptions) => client.POST_optionAWSTranslate(postOptions)}
                                baseLinks={this.props.baseLinks}
                                grammarApiMethod={(client, unusedPostOptions) =>
                                    this.props.baseLinks
                                        ? client.POST_awsBedrockGrammar(this.props.baseLinks)
                                        : { execute: () => Promise.reject("Links not loaded") }
                                }
                                pslAiGeneratedShorttext={aiGeneratedShorttext}
                                pslAiGeneratedLongtext={aiGeneratedLongtext}
                                aiGeneratedFooter={aiGeneratedFooter}
                                aiGeneratedUsp={aiGeneratedUsp}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            const { aiGeneratedShorttext, aiGeneratedLongtext, aiGeneratedFooter, aiGeneratedUsp } = getDeAiFlags(item);
            return (
                <div
                    className={className}
                    key={keyGrid}
                    style={style}
                >
                    <TargetComponent
                        t={this.props.t}
                        rowIndex={rowIndex}
                        derivates={new Map}
                        language={this.props.i18n.language}
                        uglyMode={this.state.isFullViewMode}
                        workflowReadOnly={this.props.workFlowResetStateDisabled && this.props.workFlowResetStateDisabled(key, item, readOnly)}
                        value={item[key] ? item[key] : ''}
                        onCellClick={() => this.handleOnCellClick(key, id, item[key])}
                        onChange={(newValue) => this.onDataChanged(key, id, newValue)}
                        readOnly={readOnly ? readOnly : this.props.isCellReadOnly ? this.props.isCellReadOnly(key, item, readOnly) : readOnly}
                        inEditMode={this.props.inEditMode}
                        isSpecificPSL={!!(this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey)}
                        setActiveRow={() => item._id && this.setActiveRow(item._id)}
                        clearActiveRow={this.clearActiveRow}
                        editDialogHeader={{
                            dialogTitle: this.props.t('OPTIONS_VIEW:EDIT_OPTION'),
                            previewAiHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_HEADER'),
                            previewAiSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_SUB_HEADER'),
                            previewAiOriginal: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_ORIGINAL'),
                            previewAiPreview: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_PREVIEW'),
                            previewAiConfirm: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM'),
                            previewAiCancel: this.props.t('GLOBAL:CANCEL'),
                            previewAiConfimChange: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_CONFIRM_CHANGES'),
                            previewAiGrammarSubHeader: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_GRAMMAR_SUB_HEADER'),
                            tooltipAiTranslate: this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP'),
                            tooltipAiGrammar:this.props.t('GLOBAL:GLOBAL_AI_TRANSLATE_TOOLTIP_GRAMMAR'),
                            optionCode: item.optionBasicView ? item.optionBasicView as string : "",
                            editingColumn: this.state.visibleColumns[columnIndex - 1].label,
                            optionType: item.optionTypeView ? item.optionTypeView as string : "",
                            pdipText: item.pdiptext as string
                        }}
                        client={this.props.client}
                        postOptions={this.props.postOptions}
                        apiMethod={(client, postOptions) => client.POST_optionAWSTranslate(postOptions)}
                        baseLinks={this.props.baseLinks}
                        grammarApiMethod={(client, unusedPostOptions) =>
                            this.props.baseLinks
                                ? client.POST_awsBedrockGrammar(this.props.baseLinks)
                                : { execute: () => Promise.reject("Links not loaded") }
                        }
                        pslAiGeneratedShorttext={aiGeneratedShorttext}
                        pslAiGeneratedLongtext={aiGeneratedLongtext}
                        aiGeneratedFooter={aiGeneratedFooter}
                        aiGeneratedUsp={aiGeneratedUsp}
                    />
                </div>
            );
        }
    }

    /**
     * Adds the _id and height property to data and computes the height of the row in case
     * the table is in full view mode
     */
    private appendAdditionalPropertiesToData = (data: TData[]) => {
        let extendedData: any[] = data.map((item, index) => {
            return {
                ...item,
                _id: index.toString(),
            };
        });
        return extendedData;
    }

    protected getKeyByValue(map: Map<number, string>, searchValue: string) {
        let derivateKey = 0;
        map.forEach((value, key) => {
            if (value === searchValue) {
                derivateKey = key;
            }
        });
        return derivateKey;
    }
    onBodyScroll(event: any) {
        // @ts-ignore
        if (this.props.data.length === 0 || !this || !this.gridApi) return;
        const gridBody = this.gridApi.getVerticalPixelRange();
        const totalHeight = this.gridApi.getDisplayedRowCount() * 100; // Row height * total rows
        if (gridBody.bottom >= totalHeight - 100 && !this.props.isLoadingData) {
            this.props.onLazyLoad(this.gridApi);
        }
    }
    onGridReady = (params: any) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.props.onGridReadyParent(params);
    }
    autoSizeColumn = (colId: string) => {
        if (this.columnApi) {
            this.columnApi.autoSizeColumn(colId);
        }
    }
    public render() {
        let visibleDerivates = this.getVisibleDerivates();
        const isSpecificPSL = !!(this.props.loadedPSL && this.props.loadedPSL.cnr.cnr !== PropertiesKey.BasicMarketCnrKey);
        const visibleDerivatesKeys = Array.from(visibleDerivates.keys()).map(val => val.toString());
        const availableDerivates = this.props.availableDerivates.map(der => der.objectId);
        const derivateStatesItem = this.props.columnsData.find((item) => item.key === EColumnKey.DerivateKey);
        const filterCompareDerivates = Array.from(this.state.compareAssignmentsFilterValue);
        const filterDerivatesKeys = filterCompareDerivates.map((item: string) => this.getKeyByValue(visibleDerivates, item));
        let filteredData: TData[] = [];
        let emptyDerivates: number[] = [];
        let data: TData[] = [];
        let columnsForHeightMeasurement: IVirtualizedTableColumn[] = [];
        let derivateColumnIndex = -1;
        if (!this.props.isNewGridTable) {
            derivateColumnIndex = this.state.visibleColumns.findIndex(visColumn => visColumn.key === EColumnKey.DerivateKey);
            const extendedData = this.appendAdditionalPropertiesToData(this.state.data);
            filteredData = this.filterHandler.filterPSLData(
                extendedData,
                this.state.filterValue,
                this.state.rows,
                this.props.assignmentTypeFilterValue,
                new Set(visibleDerivatesKeys),
                this.props.specificTypeOptionFilter,
                filterDerivatesKeys,
                this.props.hideEmptyAssignmentsRowsAndColumns,
                this.state.selectedIdList,
                this.state.isShowFilterData,
                this.props.dynTableSelectedIdList
            );
            emptyDerivates = this.getEmptyDerivates(Array.from(visibleDerivates.keys()), filteredData);
            data = filteredData.slice((this.state.currentPage - 1) * this.state.numberOfItems, this.state.currentPage * this.state.numberOfItems);
            columnsForHeightMeasurement = this.state.visibleColumns.filter(col => OptionColumnsForHeightMeasurement.includes(col.key));
        }

        if (this.props.isNewGridTable && this.props.flags && this.state.visibleColumns.length > 0) {
            return (
                <div className="ag-theme-alpine" id='grid-container' style={{height: 'calc(100vh - 175px)'}}>
                    <AgGridReact
                        columnDefs={
                            getPSLColumnDefs(
                                this.props,
                                visibleDerivates,
                                isSpecificPSL,
                                this.props.onNewFilterChange,
                                this.props.newDropDownFilters,
                                this.props.flags,
                                this.state.visibleColumns,
                                this.props.newGridFilters ? this.props.newGridFilters.text : '',
                                this.onDataChanged,
                                this.handleOnCellClick,
                                this.props.isCellReadOnly,
                                this.props.workFlowResetStateDisabled,
                                this.props.onApprove,
                                this.props.onChangeWorkflow,
                                this.props.onOptionWFReset,
                            )
                        }
                        defaultColDef={getDefaultColDef}
                        rowSelection="single"
                        onColumnResized={(event) => onColumnResized(event, PSL_COL_RESIZE)}
                        suppressRowClickSelection={true}
                        onModelUpdated={() => {
                            const renderTime = getGridRenderDurationAndReset();
                            if (renderTime !== null) {
                                console.log('Grid render time (ms):', renderTime);
                            }
                        }}
                        groupSelectsChildren={true}
                        rowModelType="infinite" // Enable infinite scrolling
                        pagination={false}
                        rowHeight={100}
                        cacheBlockSize={PAGE_SIZE} // Number of rows fetched per request
                        cacheOverflowSize={5} // Overflow size for cache
                        rowBuffer={5} // Number of rows to retain around the visible area
                        blockLoadDebounceMillis={100} // Delay loading of new blocks
                        suppressLoadingOverlay={false} // Prevent loading overlay
                        overlayLoadingTemplate={`
                            <div class="custom-loading-overlay">
                                <div class="spinner">
                                    <div class="double-bounce1"></div>
                                    <div class="double-bounce2"></div>
                                </div>
                            </div>
                        `}
                        gridOptions={{
                            headerHeight: 150, // Default header height
                        }}
                        onGridReady={this.onGridReady}
                        suppressCellFocus={true}
                        onSelectionChanged={this.props.onSelectionChanged}
                    />
                    <div className="ag-grid-footer">
                        <TableFooterActions
                            t={this.props.t}
                            visibleColumns={sortPSLColumnsDropdown(this.state.rowVisibleList)}
                            derivatesList={derivateStatesItem && derivateStatesItem.options && derivateStatesItem.options.derivateList
                                ? derivateStatesItem.options.derivateList
                                : new Map<number, string>()
                            }
                            availableDerivates={availableDerivates}
                            onChange={this.handleTableMenuChange}
                            loadedPSL={this.props.loadedPSL}
                            onChangeViewMode={() => this.setState({isFullViewMode: !this.state.isFullViewMode})}
                            isFullViewMode={this.state.isFullViewMode}
                            columnLabels={this.props.columnsData}
                            isSpecificMarket={this.props.isSpecificMarket}
                            compareAssignmentsFilterValue={this.state.compareAssignmentsFilterValue}
                            onFilterByComparingAssignments={this.onFilterByComparingAssignments}
                            visibleDerivates={Array.from(visibleDerivates.values())}
                            emptyDerivates={emptyDerivates}
                            hideEmptyAssignmentsRowsAndColumns={this.props.hideEmptyAssignmentsRowsAndColumns}
                            onHideEmptyAssignmentsRowsAndColumns={
                                () => {
                                    if (this.gridApi) {
                                        this.props.onNewFilterChange('hasAssignment', (!this.props.hideEmptyAssignmentsRowsAndColumns).toString());
                                    }
                                    this.props.SetHideEmptyAssignmentsRowsAndColumns(false);
                                }
                            }
                            pccdFilterValue={(this.state.filterValue[PCCDFlag] || "") as PCCDFilterEnum}
                            onFilterChange={(key, val) => this.onFilterChange({...this.state.filterValue, [key]: val})}
                            generationsRows={this.props.generationsRows}
                            isNewGridTable={this.props.isNewGridTable}
                        />
                        <TablePagination
                            numberOfItems={this.props.pageSize}
                            setNumberOfItems={this.props.setPageSize}
                            records={this.props.records}
                            dataLength={this.props.totalElements}
                            hasScrollBtn={false}
                            filteredDataLength={this.props.totalElements}
                            t={this.props.t}
                            currentPage={this.props.page}
                            isNewTable={true}
                            onPageChange={(e, c) => this.props.onPageChange(c.activePage as number, this.gridApi)}
                            customNoOfItems={[25, 50, 100]}
                            filterCount={this.props.filterCount}
                        />
                    </div>
                </div>
            );
        }
        return (
            <div className={"position--relative"}>
                {!this.props.isNewGridTable &&
                    <>
                        {/* ========== REACT VIRTUALIZED GRID ============= */}
                        {this.state.visibleColumns.length > 0 &&
                            <div id='grid-container'>
                                <AutoSizer disableHeight={true}>
                                    {({width}) => (
                                        <React.Fragment>
                                            {/* This div forces the header to be in sync with the body when scrolling
                                Also, displays the message for 'no data'*/}
                                            <div
                                                className="grid-overlay-div"
                                            >
                                                {data.length === 0 &&
                                                    <div>{this.props.t("NO_DATA")}</div>
                                                }
                                            </div>
                                            <ReactVirtualizedGrid
                                                id={virtualizedTableId}
                                                ref={(ref) => this.gridRef = ref}
                                                rowCount={data.length > 0 ? data.length + 1 : 2}
                                                rowHeight={(index) => this.getRowHeight(index, data, columnsForHeightMeasurement)}
                                                width={width}
                                                height={window.innerHeight - 176}
                                                columnCount={this.getColumnCount(visibleDerivates.size)}
                                                estimatedColumnSize={150}
                                                cellRenderer={(props: GridCellProps) => this.renderGridCell(props, data, visibleDerivates, derivateColumnIndex, filteredData)}
                                                columnWidth={(index) => this.getColumnWidth(index, visibleDerivates.size, derivateColumnIndex)}
                                                fixedRowCount={1}
                                                overscanRowCount={5}
                                                overscanColumnCount={5}
                                            />
                                        </React.Fragment>
                                    )}
                                </AutoSizer>
                            </div>
                        }
                        {/* ========== PAGINATION TABS ============= */}
                        <div className='virtualized-table-pagination-footer'>
                            <TableFooterActions
                                t={this.props.t}
                                visibleColumns={sortPSLColumnsDropdown(this.state.rowVisibleList)}
                                derivatesList={derivateStatesItem && derivateStatesItem.options && derivateStatesItem.options.derivateList
                                    ? derivateStatesItem.options.derivateList
                                    : new Map<number, string>()
                                }
                                availableDerivates={availableDerivates}
                                onChange={this.handleTableMenuChange}
                                loadedPSL={this.props.loadedPSL}
                                onChangeViewMode={() => this.setState({isFullViewMode: !this.state.isFullViewMode})}
                                isFullViewMode={this.state.isFullViewMode}
                                columnLabels={this.props.columnsData}
                                isSpecificMarket={this.props.isSpecificMarket}
                                compareAssignmentsFilterValue={this.state.compareAssignmentsFilterValue}
                                onFilterByComparingAssignments={this.onFilterByComparingAssignments}
                                visibleDerivates={Array.from(visibleDerivates.values())}
                                emptyDerivates={emptyDerivates}
                                hideEmptyAssignmentsRowsAndColumns={this.props.hideEmptyAssignmentsRowsAndColumns}
                                onHideEmptyAssignmentsRowsAndColumns={
                                    () => this.props.SetHideEmptyAssignmentsRowsAndColumns(false)
                                }
                                pccdFilterValue={(this.state.filterValue[PCCDFlag] || "") as PCCDFilterEnum}
                                onFilterChange={(key, val) => this.onFilterChange({...this.state.filterValue, [key]: val})}
                                generationsRows={this.props.generationsRows}
                            />
                            <TablePagination
                                numberOfItems={this.state.numberOfItems}
                                setNumberOfItems={this.setNumberOfItems}
                                dataLength={this.props.data.length}
                                hasScrollBtn={true}
                                filteredDataLength={filteredData.length}
                                t={this.props.t}
                                currentPage={this.state.currentPage}
                                onPageChange={(e, c) =>
                                    this.setState(
                                        {currentPage: c.activePage as number},
                                        scrollGridToTop
                                    )}
                            />
                        </div>

                        {/*this div is used to measure the height of the row before rendering*/}
                        {this.state.isFullViewMode &&
                            <div id='hidden-long-text-box' className='display--flex flex-direction--column'>
                                <p id='textarea-en' />
                                <p id='textarea-de' />
                            </div>
                        }
                    </>}
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    dynTableReload: selectVirtualizedTableReload(state),
    dynTabelRollback: selectVirtualizedTableRollback(state),
    hideEmptyAssignmentsRowsAndColumns: selectHideEmptyAssignmentsRowsAndColumns(state),
    client: selectClient(state),
    dynTableSelectedIdList: selectVirtualizedTableSelectedIdList(state),
    optionTableSort: selectOptionTableSort(state),
    userLanguage: selectLanguage(state),
    roles: selectUserRolesMemo(state),
    baseLinks: state.general.baseLinks,
    allWorkflows: state.general.workflows
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>): IMapDispatchToProps => ({
    DynTableRollBack: (dynTabelRollback) => dispatch(GeneralActions.DynTableRollBack(dynTabelRollback)),
    SetHideEmptyAssignmentsRowsAndColumns: (value) => dispatch(OptionViewActions.SetHideEmptyAssignmentsRowsAndColumns(value)),
    DynTableSetSelectedIdList: (idList) => dispatch(GeneralActions.DynTableSetSelectedIdList(idList)),
    SetOptionTableSort: (sortObject) => dispatch(OptionViewActions.SetOptionTableSort(sortObject)),
});

export default compose<React.ComponentType<any>>(
    translate(["COLUMN_FACTORY", "GLOBAL", "EXPORT", "TRANSLATION", "OPTIONS_VIEW", "WORKFLOW"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(OptionTable);



// WEBPACK FOOTER //
// ./src/views/OptionsView/OptionTable.tsx